export const HEALTH_PLAN = "health_plan";
export const PRIVATE_HEALTH_APPOINTMENT = "private_health_appointment";

export const ATTENDANCE_TYPES = [HEALTH_PLAN, PRIVATE_HEALTH_APPOINTMENT];
